import ButtonsGroupPanel from "src/Components/Common/ButtonsGroupPanel";
import setCurrentPage from "src/Utils/setCurrentPage";

const PANEL_BUTTONS_DATA = [
  {
    label: "COST OBSERVALIBILITY",
    endIcon: "arrow-right",
    type: "panel-disabled" as ButtonProps["type"],
  },
  {
    label: "cost optimization",
    onClick: () => {
      setCurrentPage(113);
    },
    endIcon: "arrow-right",
    type: "panel-enabled" as ButtonProps["type"],
  },
  {
    label: "Cognitive finops",
    onClick: () => {
      setCurrentPage(114);
    },
    endIcon: "arrow-right",
    type: "panel-enabled" as ButtonProps["type"],
  },
];

export const DATA_DOW_DEMO_DNA1_8 = {
  title: "Cost Observalibility",
  subtitle: "Data Operations Workbench demo",
  text: "<b>Where am I spending? </b>For example, costs by \ncategory, by project, by type, top 5 resources,\nand so on.",
  label: { iconPath: "start.png", text: "Cost Management" },
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "InfosysTopazLogo.png",
  next: {
    label: "END DEMO",
    onClick: () => {
      setCurrentPage(115);
    },
    type: "transparent" as "transparent",
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(111),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "DNA1/DNA1_DOW_DEMO_Video_bg.png",
  rightSideVideo: "DNA1/DNA1_DOW_DEMO_08_video.mp4",
  pageNumber: 112,
  rightSideComponent: (
    <ButtonsGroupPanel
      title={"SELECT A FEATURE"}
      panelButtons={PANEL_BUTTONS_DATA}
      panelStyle={{ position: "absolute", bottom: "96px", right: "100px" }}
    />
  ),
};
